import React, { useState, useEffect, useCallback } from 'react'
import InfoCards from 'components/InfoCards'
//import SearchInput from 'components/SearchInput'
import WorkTickIcon from 'components/icons/WorkTickIcon'
import WorkIcon from 'components/icons/WorkIcon'
import WorkCloseIcon from 'components/icons/WorkCloseIcon'
import WorkOfferIcon from 'components/icons/WorkOfferIcon'
import { Tabs,Spin} from 'antd'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  CardRow,
  SearchDiv,
  TabDiv,
  SearchInput,
  SpinWrapper
} from 'modules/Applied_Roles/Style/style'
import StyledTabs from 'components/TabsPaneStyles/index'
import SingleListed from 'modules/Applied_Roles/Style/singleListed'
import SearchIcon from 'components/icons/SearchIcon'
import { useParams } from 'react-router-dom'
const { TabPane } = Tabs
const Applied_Roles = ({
  getAppliedRoleList,
  appliedRoleList,
  getAppliedRoleMetrics,
  appliedRoleMetrics,
}) => {
  const params = useParams()
  const [filter, setFilter] = useState(params.Status || 'ACTIVE')
  const [page, setPage] = useState(1)
 
  const tabValue = params.Status
  const [search , setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  

 
  useEffect(() => {
    getAppliedRoleMetrics()
  },[])
  useEffect(() => {
    getAppliedRoleList(
      {search, filter, page,setLoading})
    
  }, [search, filter, page])

  const [cardsData, setCardsData] = useState([])
  const onChange = key => {
    setFilter(key)
    setPage(1)

  }
  const onPageChange = key => {
    setPage(key)
 
  }

  const searchValue = (value, pass) => {
    setSearch(value)

  }
  const delaySaveToDb = useCallback(
    debounce((val, pass1) => {
      searchValue(val, pass1)
    }, 1000),
    []
  )

  const handleChange = e => {
    delaySaveToDb(e.target.value, filter)
  }

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  useEffect(() => {
    const cardData = [
      {
        key: '1',
        icon: <WorkIcon />,
        text: 'Applied Jobs',
        value: appliedRoleMetrics?.appliedCount,
      },
      {
        key: '2',
        icon: <WorkTickIcon />,
        text: 'Active/Shortlisted Jobs',
        value: appliedRoleMetrics?.activeCount,
      },
      {
        key: '3',
        icon: <WorkCloseIcon />,
        text: 'Rejected',
        value: appliedRoleMetrics?.rejectedCount,
      },
      {
        key: '4',
        icon: <WorkOfferIcon />,
        text: 'Offers Received',
        value: appliedRoleMetrics?.offerIssuedCount,
      },
    ]
    setCardsData(cardData)
  }, [appliedRoleMetrics])

  return (
  
      <SectionWrapper column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Applied Roles</TopHeading>
        </TopHeader>

        <CardRow spaceBetween>
          {cardsData?.map((card,index) => (
            <InfoCards
              padding={'20px'}
              width={'25%'}
              icon={card?.icon}
              text={card?.text}
              key={index+"card"}
              value={card?.value}
            />
          ))}
        </CardRow>
        <SearchDiv>
          <SearchInput
            width={'300px'}
            onChange={handleChange}
            placeholder="Search by keyword"
            suffix={<SearchIcon />}
          />
        </SearchDiv>

        <TabDiv>
          <StyledTabs defaultActiveKey={tabValue} onChange={onChange}>
            <TabPane tab="Shortlisted" key="ACTIVE">
            {loading ? (
                        <SpinWrapper center>
                          <Spin />
                        </SpinWrapper>
                      ) : (
              <SingleListed
                dataList={appliedRoleList}
                onPageChange={onPageChange}
                page={page}
              />
              )}
            </TabPane>
      
            <TabPane tab="Rejected" key="REJECTED">
            {loading ? (
                        <SpinWrapper center>
                          <Spin />
                        </SpinWrapper>
                      ) : (
              <SingleListed
                dataList={appliedRoleList}
                onPageChange={onPageChange}
                page={page}
              />
              )}
            </TabPane>
            <TabPane tab="On Hold" key="HELD_TO_COMPARE">
            {loading ? (
                        <SpinWrapper center>
                          <Spin />
                        </SpinWrapper>
                      ) : (
              <SingleListed
                dataList={appliedRoleList}
                onPageChange={onPageChange}
                page={page}
              />
              )}
            </TabPane>
          </StyledTabs>
        </TabDiv>
      </SectionWrapper>
    
  )
}
export default Applied_Roles
